import React, { useEffect, useRef, useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import Header from './Header';
import Knoppie from './Knoppie';
import SearchBar from './SearchBar';
import ButtonGrid from './ButtonGrid';
import List from './List';
import Thumb from './Thumb';
import NoImage from '../images/no-image.png';
import useAuth from '../hooks/useAuth';
import { usePayTypesListFetch } from '../hooks/usePayTypesListFetch';

const PayTypesList = () => {
  const auth = useAuth();
  const location = useLocation();
  const from = location.state?.from || "./";
  const { paytypestate, paytypeloading, paytypeerror,paytypesearchValue, paytypesetSearchValue, paytypesetIncludeInactive, fetchPayTypesList } = usePayTypesListFetch();
  const observer = useRef();

  console.log(paytypestate)
  const lastStockItemRef = useCallback(
    
    
    (node) => {
      console.log("total pages = "+paytypestate.total_pages +" and page is " + paytypestate.page)
      if (paytypeloading || paytypestate.paytypes.length >= paytypestate.total_results) return;
      if (observer.current) observer.current.disconnect();
      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting) {
          fetchPayTypesList(paytypestate.page,paytypesearchValue);
        }
      });
      if (node) observer.current.observe(node);
    },
    [paytypeloading, fetchPayTypesList, paytypestate.page]
  );

  const username = auth.auth.user.username;
  const access = auth.auth.user.userRole;

  return (
    <>
      <Header username={username} role={access} destination={from} />

      {access === "administrator" && (
        <Knoppie destination={`/addNewStockitem`} text={'Add new Paytype'} clickable={true} from={'../StockitemsList'} />
      )}

      <div className='ListHead'>
        <SearchBar key={1} setSearchValue={paytypesetSearchValue} />
        <div>Stock Items {paytypestate.paytypes.length}/{paytypestate.total_results}</div>
        <ButtonGrid>
          <Knoppie
            text={'Show All'}
            clickable={true}
            dropdown={true}
            switchOn={true}
            callback={() => paytypesetIncludeInactive(true)}
          />
          <Knoppie
            text={'Show Active Only'}
            clickable={true}
            dropdown={true}
            switchOn={false}
            callback={() => paytypesetIncludeInactive(false)}
          />
          

        </ButtonGrid>
      </div>

      {paytypeerror && <div>Error loading stock items</div>}

      <List  destination={''}>
        <div className='PaytypeLineitem'>
        <div>code</div>
        <div>Description</div>
        <div>factor</div>
        <div>irpcode</div>
        <div>actions</div>
        </div>
        {paytypestate.paytypes.length > 0 ? (
          paytypestate.paytypes.map((item, index) => (
            <div className='PaytypeLineitem' key={item._id} ref={index === paytypestate.paytypes.length - 1 ? lastStockItemRef : null}>
              
              <div>{item.code}</div>
              <div>{item.description}</div>
              <div>{item.factor}</div>
              <div>{item.irpcode}</div>
             

              {access === "administrator" && (
                <Knoppie text={"Delete"} clickable={true} callback={() => console.log("Delete", item._id)} />
              )}
              
              
         
            </div>
          ))
        ) : (
          <div>No Paytypes found.</div>
        )}
      </List>

      {paytypeloading && <h1>Loading more items...</h1>}
    </>
  );
};

export default PayTypesList;
